import axios from 'axios'
import './axiosInterceptor'
import router from '@/router'
import { URL, DEVICEKEY } from '../variables'

export default {
  getToken (payload) {
    let data = JSON.stringify({
      name: payload.username,
      pass: payload.password
    })
    let config = JSON.stringify({
      headers: {
        'Content-Type': 'application/json'
      }
    })
    window.localStorage.clear()
    return axios
      .post(URL + '/user/login?_format=json', data, config)
      .then(res => {
        localStorage.setItem('loggedIn', true)
        localStorage.setItem('csrf_token', res.data.csrf_token)
        localStorage.setItem('logout_token', res.data.logout_token)
        localStorage.setItem('username', payload.username)
        localStorage.setItem('useruid', res.data.current_user.uid)
        localStorage.setItem(
          'auth_token',
          btoa(payload.username + ':' + payload.password)
        )
        router.push({ path: '/' })
        localStorage.setItem('errorLog', false)
        Promise.resolve(res.data)
        axios
          .get(URL + '/user/' + res.data.current_user.uid + '?_format=json')
          .then(response => {
            Promise.resolve(response.data)
            localStorage.setItem(
              'useruuid',
              !(response.data.uuid == '') ? response.data.uuid[0].value : ''
            )
            localStorage.setItem(
              'usermail',
              !(response.data.mail == '') ? response.data.mail[0].value : ''
            )
            localStorage.setItem(
              'medicblock',
              !(response.data.field_medic_dezactivat == '') ? response.data.field_medic_dezactivat[0].value : false
            )
            localStorage.setItem(
              'parent',
              !(response.data.field_user_parinte == '') ? 'true' : 'false'
            )
          })
          .catch(error => {
            console.log(error)
          })
      })
      .catch(err => {
        localStorage.clear()
        localStorage.setItem('errorLog', true)
        console.log(err)
      })
  },
  loggoutUser (payload) {
    let config = {
      headers: {
        'Content-Type': 'application/json'
      },
      'withCredentials': true
    }
    return axios
      .post(URL + '/user/logout?_format=json&token=' + payload.token + '', config)
      .then(response => {
        localStorage.setItem('loggedIn', false)
        localStorage.clear()
        Promise.resolve(response)
      })
      .catch(error => {
        Promise.reject(error)
      })
  },
  loadProgramari () {
    return axios
      .get(URL + '/api/V1/programari?_format=json')
      .then(response => Promise.resolve(response.data))
      .catch(error => {
        Promise.reject(error)
        console.log('Nu au pot fi incarcate programarile!')
      })
  },
  deleteProgramare (payload) {
    var data = {
      type: [
        {
          target_id: 'programare'
        }
      ],
      status: [
        {
          value: false
        }
      ]
    }
    let config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    return axios
      .patch(URL + '/node/' + payload.nid + '?_format=hal_json', data, config)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error))
  },
  acceptareProgramare (payload) {
    var data = {
      type: [
        {
          target_id: 'programare'
        }
      ],
      field_p_status: [
        {
          value: payload.status
        }
      ]
    }
    let config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    return axios
      .patch(URL + '/node/' + payload.nid + '?_format=hal_json', data, config)
      .then(response => {
        Promise.resolve(response.data)
        if (payload.device !== '') {
          var data = JSON.stringify({
            'notification': { 'title': payload.title, 'text': payload.text },
            'priority': 'High',
            'to': payload.device
          })

          var config = {
            method: 'post',
            url: 'https://fcm.googleapis.com/fcm/send',
            headers: {
              'Authorization': 'key=' + DEVICEKEY,
              'Content-Type': 'application/json'
            },
            data: data
          }

          axios(config)
            .then(function (response) {
              console.log(JSON.stringify(response.data))
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      })
      .catch(error => Promise.reject(error))
  },
  addProgramare (payload) {
    var data = {
      _links: {
        type: {
          href: URL + '/rest/type/node/programare'
        }
      },
      _embedded: {
        'https://appdata.dentpedia.ro/rest/relation/node/interventie/uid': [
          {
            _links: {
              self: {
                href: 'https://appdata.dentpedia.ro/user/' + payload.uid + '?_format=hal_json'
              },
              type: {
                href: 'https://appdata.dentpedia.ro/rest/type/user/user'
              }
            },
            uuid: [
              {
                value: payload.uuid
              }
            ]
          }
        ],
        'https://appdata.dentpedia.ro/rest/relation/node/programare/field_p_medic': [
          {
            _links: {
              self: {
                href: 'https://appdata.dentpedia.ro/user/' + payload.uidmedic + '?_format=hal_json'
              },
              type: {
                href: 'https://appdata.dentpedia.ro/rest/type/user/user'
              }
            },
            uuid: [
              {
                value: payload.uuidmedic
              }
            ]
          }
        ],
        'https://appdata.dentpedia.ro/rest/relation/node/programare/field_p_pacient': [
          {
            _links: {
              self: {
                href: 'https://appdata.dentpedia.ro/user/' + payload.uid + '?_format=hal_json'
              },
              type: {
                href: 'https://appdata.dentpedia.ro/rest/type/user/user'
              }
            },
            uuid: [
              {
                value: payload.uuid
              }
            ]
          }
        ]
      },
      type: [
        {
          target_id: 'programare'
        }
      ],
      field_p_service: [
        {
          value: payload.service
        }
      ],
      field_p_status: [
        {
          value: 'p2'
        }
      ],
      field_p_data: [
        {
          value: payload.datastart
        }
      ],
      field_p_data_end: [
        {
          value: payload.dataend
        }
      ]
    }
    let config = {
      headers: {
        'Content-Type': 'application/hal+json'
      }
    }
    return axios
      .post(
        URL + '/node?_format=hal_json',
        data,
        config
      )
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error))
  },
  editProgramare (payload) {
    var data = {
      type: [
        {
          target_id: 'programare'
        }
      ],
      field_p_status: [
        {
          value: payload.status
        }
      ],
      field_p_service: [
        {
          value: payload.service
        }
      ],
      field_p_data: [
        {
          value: payload.datastart
        }
      ],
      field_p_data_end: [
        {
          value: payload.dataend
        }
      ]
    }
    let config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    return axios
      .patch(URL + '/node/' + payload.nid + '?_format=hal_json', data, config)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error))
  },
  loadProfil () {
    return axios
      .get(URL + '/api/V1/medic/' + localStorage.getItem('useruid') + '?_format=json')
      .then(response => Promise.resolve(response.data))
      .catch(error => {
        Promise.reject(error)
        console.log('Nu au poate fi incarcat profilul!')
      })
  },
  loadMediciCabinet () {
    return axios
      .get(URL + '/api/v1/medic-cabinet/' + localStorage.getItem('useruid') + '?_format=json')
      .then(response => Promise.resolve(response.data))
      .catch(error => {
        Promise.reject(error)
        console.log('Nu au pot fi incarcati medici!')
      })
  },
  loadRid () {
    return axios
      .get(URL + '/api/v1/medic/rid/' + localStorage.getItem('useruid') + '?_format=json')
      .then(response => Promise.resolve(response.data))
      .catch(error => {
        Promise.reject(error)
        console.log('Nu poate fi incarcata cerinta!')
      })
  },
  loadPacienti () {
    return axios
      .get(URL + '/api/V1/pacienti?_format=json')
      .then(response => Promise.resolve(response.data))
      .catch(error => {
        Promise.reject(error)
        console.log('Nu au pot fi incarcati pacientii!')
      })
  },
  loadInterventii () {
    return axios
      .get(URL + '/api/V1/interventii?_format=json')
      .then(response => Promise.resolve(response.data))
      .catch(error => {
        Promise.reject(error)
        console.log('Nu au pot fi incarcate interventiile!')
      })
  },
  loadProceduri () {
    return axios
      .get(URL + '/api/V1/proceduri?_format=json')
      .then(response => Promise.resolve(response.data))
      .catch(error => {
        Promise.reject(error)
        console.log('Nu au pot fi incarcate procedurile!')
      })
  },
  editProcedura (payload) {
    var data = {
      id: [
        {
          value: payload.id
        }
      ],
      type: [
        {
          target_id: 'interventie'
        }
      ],
      parent_id: [
        {
          value: payload.nid
        }
      ],
      parent_type: [
        {
          value: 'node'
        }
      ],
      parent_field_name: [
        {
          value: 'field_interventie'
        }
      ],
      field_data: [
        {
          value: payload.data
        }
      ],
      field_pret: [
        {
          value: payload.price
        }
      ],
      field_descriere: [
        {
          value: payload.desc
        }
      ],
      field_platit: [
        {
          value: payload.statusplatit
        }
      ]
    }
    let config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    return axios
      .patch(URL + '/entity/paragraph/' + payload.id + '?_format=hal_json', data, config)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error))
  },
  deleteProcedura (payload) {
    var data = {
      id: [
        {
          value: payload.id
        }
      ],
      type: [
        {
          target_id: 'interventie'
        }
      ],
      parent_id: [
        {
          value: payload.nid
        }
      ],
      parent_type: [
        {
          value: 'node'
        }
      ],
      status: [
        {
          value: false
        }
      ]
    }
    let config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    return axios
      .delete(URL + '/entity/paragraph/' + payload.id + '?_format=hal_json', data, config)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error))
  },
  addProcedura (payload) {
    var data = {
      _links: {
        type: {
          href: 'https://appdata.dentpedia.ro/rest/type/paragraph/interventie'
        }
      },
      type: [
        {
          target_id: 'interventie'
        }
      ],
      parent_id: [
        {
          value: payload.nid
        }
      ],
      parent_type: [
        {
          value: 'node'
        }
      ],
      parent_field_name: [
        {
          value: 'field_interventie'
        }
      ],
      field_data: [
        {
          value: payload.data
        }
      ],
      field_pret: [
        {
          value: payload.price
        }
      ],
      field_descriere: [
        {
          value: payload.desc
        }
      ],
      field_platit: [
        {
          value: payload.statusplatit
        }
      ]
    }
    let config = {
      headers: {
        'Content-Type': 'application/hal+json'
      }
    }
    return axios
      .post(URL + '/entity/paragraph?_format=hal_json', data, config)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error))
  },
  addInterventie (payload) {
    var data = {
      _links: {
        type: {
          href: URL + '/rest/type/node/interventie'
        }
      },
      type: [
        {
          target_id: 'interventie'
        }
      ],
      _embedded: {
        'https://appdata.dentpedia.ro/rest/relation/node/interventie/field_pacient_inter': [
          {
            _links: {
              self: {
                href: URL + '/user/' + payload.uidpacient + '?_format=hal_json'
              },
              type: {
                href: URL + '/rest/type/user/user'
              }
            },
            uuid: [
              {
                value: payload.uuidpacient
              }
            ]
          }
        ]
      },
      field_tip_interventie: [
        {
          value: payload.intervention
        }
      ]
    }
    let config = {
      headers: {
        'Content-Type': 'application/hal+json'
      }
    }
    return axios
      .post(URL + '/node?_format=hal_json', data, config)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js